import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({'g-3': true, 'px-3': true, 'pt-3': true, 'me-4': true })
}
const _hoisted_2 = { class: "mt-3 me-5 d-flex justify-content-end" }
const _hoisted_3 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FormGridColumn = _resolveComponent("FormGridColumn")!
  const _component_FormGridLocal = _resolveComponent("FormGridLocal")!
  const _directive_validation_form = _resolveDirective("validation-form")!

  return _withDirectives((_openBlock(), _createElementBlock("form", {
    class: "cdes-page",
    novalidate: "",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.sendEmail()), ["prevent"]))
  }, [
    _createVNode(_component_FormGridLocal, {
      columns: 1,
      labelWidth: 8
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_FormGridColumn, null, {
            default: _withCtx(() => [
              _createVNode(_component_TextInput, {
                label: _ctx.$t("general.email.from"),
                modelValue: this.sender.organisationPersonEmailAddress,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.sender.organisationPersonEmailAddress) = $event)),
                disabled: true
              }, null, 8, ["label", "modelValue"]),
              _createVNode(_component_TextInput, {
                label: _ctx.$t("general.email.to"),
                modelValue: this.recipientAddresses,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.recipientAddresses) = $event)),
                disabled: true,
                tag: 'textarea',
                rows: this.recipients?.length ?? 1
              }, null, 8, ["label", "modelValue", "rows"]),
              _createVNode(_component_TextInput, {
                label: _ctx.$t("general.email.subject"),
                modelValue: this.subject,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.subject) = $event)),
                required: ""
              }, null, 8, ["label", "modelValue"]),
              _createVNode(_component_TextInput, {
                label: _ctx.$t("general.email.content"),
                modelValue: this.content,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.content) = $event)),
                tag: 'textarea',
                rows: 10
              }, null, 8, ["label", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary me-2",
            onClick: _cache[4] || (_cache[4] = ($event: any) => {this.$router.back();})
          }, _toDisplayString(_ctx.$t("general.cancel")), 1),
          _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.$t("general.send")), 1)
        ])
      ]),
      _: 1
    })
  ], 544)), [
    [_directive_validation_form]
  ])
}